export default __webpack_public_path__ + "static/casestudy-img-ai-731e92826883b985050a92d1ab484ede.jpg";